'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autoComplete = require('material-ui/lib/auto-complete');

var _autoComplete2 = _interopRequireDefault(_autoComplete);

var _menuItem = require('material-ui/lib/menus/menu-item');

var _menuItem2 = _interopRequireDefault(_menuItem);

var _dialog = require('material-ui/lib/dialog');

var _dialog2 = _interopRequireDefault(_dialog);

var _Image = require('./../Image');

var _Image2 = _interopRequireDefault(_Image);

var _BinaryTextBox = require('./../BinaryTextBox');

var _BinaryTextBox2 = _interopRequireDefault(_BinaryTextBox);

var _BinaryButton = require('./../BinaryButton');

var _BinaryButton2 = _interopRequireDefault(_BinaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var BinaryAutoComplete = function (_Component) {
  _inherits(BinaryAutoComplete, _Component);

  function BinaryAutoComplete(props) {
    _classCallCheck(this, BinaryAutoComplete);

    var _this = _possibleConstructorReturn(this, (BinaryAutoComplete.__proto__ || Object.getPrototypeOf(BinaryAutoComplete)).call(this, props));

    var _this$props = _this.props,
        data = _this$props.data,
        defaultData = _this$props.defaultData;

    _this.state = {
      open_comment: false,
      selected: {},
      newRequest: false,
      update: {},
      data: [],
      comment_text: ''
    };
    _this.state.selected = Object.assign({}, defaultData);
    _this.state.update = Object.assign({}, defaultData);
    _this.state.data = data;
    _this.styles = require('./BinaryAutoComplete.scss');
    return _this;
  }

  _createClass(BinaryAutoComplete, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.state.selected = Object.assign({}, nextProps.defaultData);
      this.state.update = Object.assign({}, nextProps.defaultData);
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      var _this2 = this;

      var onSelect = this.props.onSelect;

      if (this.state.selected.id) {
        var comment = this.state.comment_text;
        onSelect(this.state.selected, comment);
        this.setState({
          update: Object.assign({}, this.state.selected)
        }, function () {
          _this2.hideButtons();
          _this2.closeComment();
        });
      } else {
        this.hideButtons();
      }
    }
  }, {
    key: 'onUnSelect',
    value: function onUnSelect() {
      var _this3 = this;

      if (this.state.update.id) {
        this.loadSelected(Object.assign({}, this.state.update), false);
      } else {
        this.loadSelected({});
        var autoComplete = this.refs.autocomplete;
        setTimeout(function () {
          return autoComplete && autoComplete.setState({ searchText: '' });
        }, 10);
      }
      this.hideButtons();
      setTimeout(function () {
        _this3.closeComment();
      }, 50);
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (!this.state.newRequest) {
        this.onUnSelect();
      }
      this.setState({
        newRequest: false
      });
    }
  }, {
    key: 'onNewRequest',
    value: function onNewRequest(charObj) {
      this.setState({
        newRequest: true
      });
      this.loadAutoComplete(charObj.text);
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate(chars) {
      this.loadAutoComplete(chars);
    }
  }, {
    key: 'onFocus',
    value: function onFocus(event) {
      this.loadAutoComplete(event.target.value);
    }
  }, {
    key: 'onChangeCommentText',
    value: function onChangeCommentText(value) {
      this.setState({
        comment_text: value
      });
    }
  }, {
    key: 'getImage',
    value: function getImage(src) {
      var url = src;
      if (src === '' || src === null || typeof src === 'undefined') {
        url = '/img/no-pic.png';
      }
      return _react2.default.createElement(_Image2.default, { src: url, responsive: true, variant: 'circle' });
    }
  }, {
    key: 'loadAutoComplete',
    value: function loadAutoComplete(chars) {
      var data = this.props.data;

      var DATA = [];
      DATA = data.filter(function (item) {
        return item.name !== null ? item.name.toLowerCase().indexOf(chars.trim().toLowerCase()) === 0 : item.id;
      });
      this.showButtons();
      this.setState({
        selected: {},
        data: DATA
      });
    }
  }, {
    key: 'showButtons',
    value: function showButtons() {
      if (this.refs.select && this.refs.unselect) {
        this.refs.select.className = this.styles.select + ' show';
        this.refs.unselect.className = this.styles.unselect + ' show';
      }
    }
  }, {
    key: 'hideButtons',
    value: function hideButtons() {
      if (this.refs.select && this.refs.unselect) {
        this.refs.select.className = this.styles.select + ' hide';
        this.refs.unselect.className = this.styles.unselect + ' hide';
      }
    }
  }, {
    key: 'openComment',
    value: function openComment() {
      this.setState({
        open_comment: true
      });
    }
  }, {
    key: 'closeComment',
    value: function closeComment() {
      this.setState({
        open_comment: false
      });
    }
  }, {
    key: 'loadSelected',
    value: function loadSelected(data) {
      var _this4 = this;

      var unselect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _props = this.props,
          defaultData = _props.defaultData,
          includeComment = _props.includeComment;

      this.setState({
        selected: data === null ? defaultData : data
      }, function () {
        if (includeComment && data !== null && unselect) {
          if (typeof data.id !== 'undefined') {
            _this4.openComment();
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          hintText = _props2.hintText,
          includeImage = _props2.includeImage,
          imgBool = _props2.imgBool,
          disabled = _props2.disabled,
          includeComment = _props2.includeComment,
          showIcon = _props2.showIcon,
          customClass = _props2.customClass,
          maxSearchResults = _props2.maxSearchResults;

      var dataSource = [];
      var display = includeImage ? { 'display': 'inline' } : { 'display': 'none' };
      var selectionName = this.state.selected !== null ? this.state.selected.name : '';

      this.state.data.forEach(function (item) {
        var name = item.name;
        dataSource.push({
          text: item.name,
          value: _react2.default.createElement(_menuItem2.default, {
            style: { 'fontSize': '14px', 'width': '180px' },
            listStyle: { 'width': '200px', 'color': 'red' },
            menuStyle: { 'width': '200px', 'color': 'red' },
            onTouchTap: _this5.loadSelected.bind(_this5, item),
            secondaryText: name,
            name: name,
            primaryText: includeImage && _react2.default.createElement(
              'div',
              { style: display, className: _this5.styles.binary_auto_complete_img },
              _this5.getImage(item.img)
            )
          })
        });
      });

      return _react2.default.createElement(
        'div',
        { className: this.styles.binary_auto_complete_container + ' ' + customClass },
        imgBool && _react2.default.createElement(
          'div',
          { ref: 'autocomplete_container', className: this.styles.binary_auto_complete_main_img },
          this.state.selected && this.getImage(this.state.selected.img)
        ),
        showIcon && _react2.default.createElement('i', { className: 'fa fa-pencil' }),
        _react2.default.createElement(_autoComplete2.default, {
          hintText: hintText,
          searchText: selectionName !== null ? selectionName : '',
          filter: maxSearchResults !== undefined ? _autoComplete2.default.fuzzyFilter : _autoComplete2.default.noFilter,
          dataSource: dataSource,
          ref: 'autocomplete',
          fullWidth: true,
          maxSearchResults: maxSearchResults !== undefined ? maxSearchResults : '',
          disabled: disabled,
          openOnFocus: true,
          id: 'binary_auto_complete',
          onFocus: this.onFocus.bind(this),
          onNewRequest: this.onNewRequest.bind(this),
          onBlur: this.onBlur.bind(this),
          onUpdateInput: this.onUpdate.bind(this),
          labelStyle: { 'fontSize': '14px' },
          hintStyle: { 'fontSize': '14px', 'bottom': '8px' },
          menuStyle: { 'width': '180px', 'fontSize': '14px', 'maxHeight': '400px', 'overflow': 'auto' },
          listStyle: { 'width': '180px', 'fontSize': '10px', 'zIndex': 99999 },
          style: { 'width': '180px', 'marginLeft': '6px', 'fontSize': '14px', 'marginTop': '-8px', 'position': 'absolute' }
        }),
        includeComment && _react2.default.createElement(
          _dialog2.default,
          {
            title: 'Reason',
            modal: false,
            open: this.state.open_comment,
            onRequestClose: this.onUnSelect.bind(this)
          },
          _react2.default.createElement(
            'div',
            { ref: 'comment', className: this.styles.binary_auto_complete_comment },
            _react2.default.createElement(_BinaryTextBox2.default, {
              ref: 'comment_textarea',
              key: 'comment_textarea',
              floatingLabelText: 'Reason for changing owner...',
              onChange: this.onChangeCommentText.bind(this),
              className: 'comment_textarea',
              name: 'comment'
            }),
            _react2.default.createElement(
              'div',
              { className: this.styles.binary_auto_complete_buttons },
              _react2.default.createElement(_BinaryButton2.default, {
                ref: 'unselect',
                label: 'Cancel',
                style: { marginRight: '10px' },
                onClick: this.onUnSelect.bind(this)
              }),
              _react2.default.createElement(_BinaryButton2.default, {
                ref: 'select',
                label: 'Submit',
                disabled: this.state.comment_text.length < 4,
                style: { marginRight: '10px' },
                keyboardFocused: true,
                onClick: this.onSelect.bind(this)
              })
            )
          )
        ),
        !includeComment && _react2.default.createElement(
          'div',
          { className: this.styles.binary_auto_complete_buttons },
          _react2.default.createElement(
            'div',
            { onClick: this.onUnSelect.bind(this), ref: 'unselect', className: this.styles.unselect },
            _react2.default.createElement('i', { className: 'fa fa-close' })
          ),
          _react2.default.createElement(
            'div',
            { onClick: this.onSelect.bind(this), ref: 'select', className: this.styles.select },
            _react2.default.createElement('i', { className: 'fa fa-check' })
          )
        )
      );
    }
  }]);

  return BinaryAutoComplete;
}(_react.Component);

BinaryAutoComplete.propTypes = {
  onSelect: _propTypes2.default.func,
  includeComment: _propTypes2.default.bool,
  includeImage: _propTypes2.default.bool,
  imgBool: _propTypes2.default.bool,
  rootClose: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  hintText: _propTypes2.default.string,
  headerText: _propTypes2.default.string,
  defaultData: _propTypes2.default.object,
  data: _propTypes2.default.array, // id, name, img
  showIcon: _propTypes2.default.bool,
  customClass: _propTypes2.default.string,
  maxSearchResults: _propTypes2.default.number
};
BinaryAutoComplete.defaultProps = {
  rootClose: false,
  includeImage: false,
  includeComment: true,
  disabled: false,
  imgBool: false,
  showIcon: true,
  showButtons: true,
  maxSearchResults: 10
};
exports.default = BinaryAutoComplete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryAutoComplete/BinaryAutoComplete.js
// module id = 2156
// module chunks = 1